import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CrackingRunGrowerReadyService = {
  /**
   * Fetch cracking run batches for the Grower Ready screen.
   * @param {Object} params
   * @param {number}  params.season   - Required season year
   * @param {string} [params.grower]  - Optional grower code (omit or "" for all)
   * @param {string} [params.variety] - Optional variety code (omit or "" for all)
   * @param {string} [params.dateFrom] - Optional ISO date string (run from date)
   * @param {string} [params.dateTo]   - Optional ISO date string (run to date)
   */
  async getList(params) {
    let url = `api/CrackingRunGrowerReadyList?season=${params.season}`;
    if (params.grower) url += `&grower=${encodeURIComponent(params.grower)}`;
    if (params.variety) url += `&variety=${encodeURIComponent(params.variety)}`;
    if (params.dateFrom) url += `&dateFrom=${encodeURIComponent(params.dateFrom)}`;
    if (params.dateTo) url += `&dateTo=${encodeURIComponent(params.dateTo)}`;
    return await ApiService.get(url);
  },

  /**
   * Persist IsReadyForGrower state for all visible batches.
   * @param {Array<{ParentRunNumber: string, SeasonYear: number, IsReadyForGrower: boolean}>} payload
   */
  async save(payload) {
    return await ApiService.post("api/Save_CrackingRunGrowerReady", payload);
  },

  /**
   * OData data source for the Season Year filter dropdown.
   * Returns rows with SeasonYear field, sorted descending.
   */
  seasonDataSource() {
    return ApiService.createDataSource("api/AlmondcoIntakeSeason", {
      select: ["SeasonYear"],
      sort: [{ selector: "SeasonYear", desc: true }],
    });
  },

  /**
   * OData data source for the Grower filter dropdown.
   * Filtered to the selected season.
   * @param {number} season
   */
  growerDataSource(season) {
    return ApiService.createDataSource("api/CrackingRunGrowerList", {
      filter: season ? [["SeasonYear", "=", season]] : undefined,
      select: ["GrowerCode", "GrowerName"],
      sort: [{ selector: "GrowerName", asc: true }],
    });
  },

  /**
   * OData data source for the Variety filter dropdown.
   */
  varietyDataSource() {
    return ApiService.createDataSource("api/AlmondcoIntakeVariety", {
      select: ["VarietyCode", "Description"],
      sort: [{ selector: "Description", asc: true }],
    });
  },
};

export { CrackingRunGrowerReadyService };
